export const PLAYLIST_BY_ID_REQUEST = "PLAYLIST_BY_ID_REQUEST";
export const PLAYLIST_BY_ID_RECEIVE = "PLAYLIST_BY_ID_RECEIVE";

export const PLAYLIST_ITEM_ADD = "PLAYLIST_ITEM_ADD";
export const PLAYLIST_ITEM_ADD_COMPLETED = "PLAYLIST_ITEM_ADD_COMPLETED";

export const PLAYLIST_ITEM_DELETE = "PLAYLIST_ITEM_DELETE";
export const PLAYLIST_ITEM_DELETE_COMPLETED = "PLAYLIST_ITEM_DELETE_COMPLETED";
